export const INQUIRY_CATEGORIES = [
  { value: 'general', label: '일반 문의' },
  { value: 'story', label: '동화/주인공' },
  { value: 'payment', label: '결제' },
  { value: 'account', label: '계정' },
  { value: 'app', label: '앱 제작' },
  { value: 'etc', label: '기타' },
]

export const INQUIRY_STATUSES = [
  { value: 'WAITING', label: '답변 대기' },
  { value: 'ANSWERED', label: '답변 완료' },
  { value: 'CLOSED', label: '종료' },
]

export const CATEGORY_LABELS = INQUIRY_CATEGORIES.reduce((acc, item) => {
  acc[item.value] = item.label
  return acc
}, {})

export const STATUS_LABELS = INQUIRY_STATUSES.reduce((acc, item) => {
  acc[item.value] = item.label
  return acc
}, {})

export const STATUS_BADGE_CLASS = {
  WAITING: 'bg-amber-50 text-amber-700',
  ANSWERED: 'bg-green-50 text-new-green',
  CLOSED: 'bg-gray-100 text-gray-500',
}

export const normalizeInquiryList = (response) => {
  if (!response) return []
  if (Array.isArray(response)) return response
  return response.items || []
}

export const formatInquiryDate = (datetime) => {
  if (!datetime) return '-'
  return datetime.replace('T', ' ')
}

export const getLocalHeroes = () => {
  try {
    return JSON.parse(localStorage.getItem('heroes')) || []
  } catch (e) {
    return []
  }
}

export const getHeroName = (hero) => {
  if (!hero) return ''
  return `${hero.lastName || ''}${hero.firstName || ''}` || hero.firstName || ''
}

export const getApiErrorMessage = (error, fallbackMessage) => {
  return (error.response && error.response.data && error.response.data.message) || error.message || fallbackMessage
}
